import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonTitle from '../../../common-components/common-title';

const krdvTeam1 = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Букуров',
            crewItemSubtitle: 'руководитель проекта',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Шпигальский',
            crewItemSubtitle: 'менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Иван Поддубный',
            crewItemSubtitle: 'руководитель группы разработки',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Петр Кленкин',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Буланов',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Павел Воробьев',
            crewItemSubtitle: 'frontend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Близнюк',
            crewItemSubtitle: 'frontend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Мария Лапиева',
            crewItemSubtitle: 'frontend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший дизайнер',
        },
    ],
};

const krdvTeam2 = {
    crewTitle: 'Корпорация развития Дальнего Востока',
    crewSubtitle: 'Выражаем благодарность команде корпорации за помощь в работе над проектом:',
    crewList: [
        {
            crewItemImg: null,
            crewItemTitle: 'Николай Запрягаев',
            crewItemSubtitle:
                'заместитель генерального директора по резидентской политике и проектному управлению',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Руслан Кабиров',
            crewItemSubtitle:
                'заместитель начальника отдела развития и поддержки систем департамента информационных технологий',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Сергей Науменко',
            crewItemSubtitle:
                'главный специалист отдела развития и поддержки систем департамента информационных технологий',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Сергей Дайнеко',
            crewItemSubtitle: 'заместитель директора департамента информационных технологий',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Олег Тележников',
            crewItemSubtitle: 'заместитель директор департамента по развитию ТОР и СПВ',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Андрей Долгов',
            crewItemSubtitle: 'заместитель директора департамента эксплуатации инфраструктуры',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Сергей Скалий',
            crewItemSubtitle: 'директор департамента по развитию ТОР и СПВ',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <FullWrapper className="team">
                <CommonTitle>Команда</CommonTitle>
                <CommonUsualText className="team__text-info">
                    Каждому клиенту мы предоставляем отдельную проектную команду. Над созданием
                    проекта для Корпорации развития Дальнего Востока работали 10 человек с нашей
                    стороны и 7 человек со стороны заказчика:
                </CommonUsualText>
                <CrewContainer container={krdvTeam1} />
                <CrewContainer container={krdvTeam2} />
            </FullWrapper>
        );
    }
}

export default Team;
